// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2GtIa","empty":"ModalGraph_empty__1LeLt"};